import defaultTablesOptions from '../сonfig-and-helpers/default-tables-options';
import { gridDateStringValueFormatter } from '../сonfig-and-helpers/helpers';

function housingReportGridOptions(classReference, type) {
    const defaultOptions = defaultTablesOptions(classReference);

    // change default Grid options.
    defaultOptions.defaultColDef.sortable = false;
    defaultOptions.defaultColDef.floatingFilter = false;

    defaultOptions.enableCharts = false;
    defaultOptions.enableRangeSelection = false;

    defaultOptions.sideBar = [];

    return {
        ...defaultOptions,

        columnDefs: [
            {
                headerName: 'Date',
                field: 'report_date',
                filter: 'agDateColumnFilter',
                cellDataType: 'dateString',
                cellClass: 'DateString',
                sort: 'desc',
                sortable: true,
                width: 150,
                minWidth: 150,
                maxWidth: 250,
                valueFormatter: gridDateStringValueFormatter,
            },
            {
                headerName: 'Description',
                field: 'description',
                width: 400,
                minWidth: 400,
                cellRenderer: (params) => {
                    let out = document.createElement('div');
                    out.innerHTML = params.data.description;
                    return out;
                },
            },
        ],
        overlayNoRowsTemplate: 'No reports available at this time',
    };
}
export default housingReportGridOptions;
